import { compose } from "redux";
import { connect } from "react-redux";
import { Fade } from "@material-ui/core";
import React, { PureComponent } from "react";

import { togglePanel } from "app/app.actions";
import { isPanelOpen } from "app/app.selectors";

class SimplePanelContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.togglePanel = this.togglePanel.bind(this);
  }

  togglePanel = () => this.props.dispatchTogglePanel(this.props.panelId);

  render() {
    const { children, open } = this.props;

    return (
      <>
        {open && (
          <Fade in>
            {React.cloneElement(React.Children.only(children), {
              open,
              togglePanel: this.togglePanel,
            })}
          </Fade>
        )}
      </>
    );
  }
}

export default compose(
  connect(
    (state, { panelId }) => ({
      open: isPanelOpen(state, panelId),
    }),
    {
      dispatchTogglePanel: togglePanel,
    },
  ),
)(SimplePanelContainer);
